import ReactECharts from 'echarts-for-react';
import echarts from '../echarts';
import { COMPETITOR_DIMENSIONS, COMPETITOR_DATA } from '../data/mockData';

// 区块5：竞品对比雷达图
export default function ChartRadarCompetitor() {
  const colors = ['#fbbf24', '#06b6d4', '#f97316', '#22c55e', '#a855f7'];

  const option = {
    backgroundColor: 'transparent',
    title: {
      text: '竞品多维度对比分析',
      left: 'center',
      textStyle: { color: '#fbbf24', fontSize: 20, fontWeight: 'bold' },
    },
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#fbbf24',
      textStyle: { color: '#fff' },
    },
    legend: {
      data: COMPETITOR_DATA.map((d) => d.name),
      bottom: 0,
      textStyle: { color: '#cbd5e1', fontSize: 13 },
    },
    radar: {
      indicator: COMPETITOR_DIMENSIONS.map((name) => ({
        name,
        max: 100,
        nameTextStyle: { color: '#e2e8f0', fontSize: 14, fontWeight: 'bold' },
      })),
      shape: 'polygon',
      splitNumber: 5,
      splitLine: { lineStyle: { color: 'rgba(255,255,255,0.12)' } },
      splitArea: {
        show: true,
        areaStyle: {
          color: ['rgba(251,191,36,0.03)', 'rgba(251,191,36,0.06)', 'rgba(251,191,36,0.03)', 'rgba(251,191,36,0.06)', 'rgba(251,191,36,0.03)'],
        },
      },
      axisLine: { lineStyle: { color: 'rgba(255,255,255,0.15)' } },
    },
    series: [
      {
        name: '竞品对比',
        type: 'radar',
        data: COMPETITOR_DATA.map((item, index) => ({
          value: item.value,
          name: item.name,
          itemStyle: { color: colors[index] },
          lineStyle: { width: item.name === '数师有方' ? 4 : 2 },
          areaStyle: { color: colors[index] + (item.name === '数师有方' ? '33' : '15') },
          symbolSize: item.name === '数师有方' ? 8 : 5,
        })),
        animationDuration: 1500,
      },
    ],
  };

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      style={{ width: '100%', height: '100%', minHeight: 460 }}
      opts={{ renderer: 'svg' }}
    />
  );
}
